export class ItemGridColumns {
    public static TotalWithoutTax_WithDiscount: string = 'Total_WithoutTax_WithDiscounts';
    public static TotalTax_WithDiscounts: string = 'Total_Tax_WithDiscounts';
    public static Total_WithDiscounts: string = 'Total_WithDiscounts';

    public static TotalWithoutTax_WithoutDiscounts: string = 'Total_WithoutTax_WithoutDiscounts';
    public static TotalTax_WithoutDiscounts: string = 'Total_Tax_WithoutDiscounts';
    public static Total_WithoutDiscounts: string = 'Total_WithoutDiscounts';

    public static Total_Addition: string = 'Addition';
    public static Total_Margin: string = 'Margin';

    
    public static IsRoundedRow: string = 'IsRoundedRow';
    public static TaxRate: string = 'TaxRate_FK';
    public static TaxIncluded: string = 'TaxIncluded';
    public static Quantity: string = 'Quantity';
    public static UnitPrice: string = 'UnitPrice';
    public static UnitPriceDiscountPercentage: string = 'UnitPriceDiscountPercentage';
    public static UnitPriceDiscount: string = 'UnitPriceDiscount';
    public static CostPrice: string = 'CostPrice';
}
